import axios from '../axios'
/*
 * 系统认证模块
 */
/**
 * 用户登录
 * @param data
 */
export const login = data => {
  return axios({
    url: 'login',
    method: 'post',
    data
  })
}
/**
 * 用户登出
 */
export const logout = () => {
  return axios({
    url: 'logout',
    method: 'get'
  })
}
/**
 * 修改密码
 * @param data
 */
export const passwdUpdate = (data) => {
  return axios({
    url: '/authc/update/password',
    method: 'put',
    data
  })
}
/**
 * 判定用户是否登录
 */
export const isAuthenticated = () => {
  return axios({
    url: '/authc/authenticated',
    method: 'get'
  })
}
/**
 * 获取用户token(oauth2)
 * @param data
 */
export const getToken = (data) => {
  return axios({
    url: '/authc/token',
    method: 'get',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/authc.js